import { render, staticRenderFns } from "./framework-sidebar.vue?vue&type=template&id=ae9f1c0a&scoped=true&"
import script from "./framework-sidebar.vue?vue&type=script&lang=js&"
export * from "./framework-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./framework-sidebar.vue?vue&type=style&index=0&id=ae9f1c0a&prod&scoped=true&lang=css&"
import style1 from "./framework-sidebar.vue?vue&type=style&index=1&id=ae9f1c0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9f1c0a",
  null
  
)

export default component.exports